import {HttpHandler} from "../../../utils/handler/HttpHandler";
import {withoutComma} from "../../../utils/calculate/Amount";

export class BilateralContractService {
    constructor(){
        this.httpHandler = new HttpHandler();
        this.axiosInstance = this.httpHandler.createInstance('/bilateral/contract');
    }

    /**
     * Función que hace una llamada al back para consultar la lista para
     * llenar la pantalla de contrato bilateral.
     * @returns {Promise<any>} Respuesta que contiene la lista de
     * contratos o regresa un error, cuando no puede consultar.
     */
    getBilateralContract() {
        return this.axiosInstance({
            method: 'get'
        }).then(res => res);
    }

    /**
     * Función que hace post al back para crear un contrato previamente seleccionado.
     * @param dataContract Objeto a editar
     * @returns {Promise<any>} Mensaje de éxito o error al crear el contrato.
     */
    createBilateralContract(dataContract) {
        return this.axiosInstance({
            url: '/create',
            method: 'post',
            data: {
                borrowerId: dataContract.borrowerId,
                haircut: dataContract.haircut,
                threshold: Number(withoutComma(dataContract.threshold))
            }
        }).then(res => res);
    }

    /**
     * Función que hace put al back para modificar un contrato
     * previamente seleccionado.
     * @param dataContract Objeto a editar
     * @returns {Promise<any>} Mensaje de éxito o error al modificar el contrato.
     */
    editBilateralContract(dataContract) {
        return this.axiosInstance({
            url: dataContract.id + '/update',
            method: 'patch',
            data: {
                haircut: dataContract.haircut,
                threshold: Number(withoutComma(dataContract.threshold))
            }
        }).then(res => res);
    }
}